import React from 'react'
import '../../assets/css/a4.css';
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, getUserSettings} from '../../storage'
import PurchaseA4 from './previews/purchasea4.js'
import PurchasePharma from './previews/purchasepharma'
import {Link } from 'react-router-dom'
import {Loader} from '../../utils/misc'
const A4Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 210mm; min-height: 280mm;} @page {margin: 0;size: A4 portrait;min-height: 0;}"}
  </style>
)

const A4Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 297mm;min-height: 190mm; } @page {margin: 0;size: A4 landscape;min-height: 0;}"}
  </style>
)

const A5Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 148mm; min-height: 190mm;} @page {margin: 0;size: A5 portrait;min-height: 0;}"}
  </style>
)

const A5Landscape = () =>(
  <style>
{".preview-a4,.pharma-a5  {width: 210mm;min-height: 0; } @page {margin: 0;size: A5 landscape;min-height: 0;}"}
  </style>
)

function invoiceFont(size) {
  return <style>
  {".preview-a4,.pharma-a5{font-size: " + size + "px; }"
  +".preview-a4 .company-name {font-size: " + (size+7) + "px; } "
  + " .preview-a4 .table,.pharma-a5 .table {font-size: " + (size-1) + "px; }  "
   +"@page {font-size:" + size + "px;}"
   +"@print { .preview-a4 .table,.pharma-a5 .table  {font-size: " + (size-1) + "px; }"
    +".preview-a4 .company-name {font-size: " + (size+7) + "px; }}"
   }
  </style>
}


export default class PreviewPurchase extends React.Component {

  constructor(props){
    super(props)
    this.getPurchase = this.getPurchase.bind(this)
    this.editLink = this.editLink.bind(this)
    this.print = this.print.bind(this)

    this.state = {loading:true, downloading:false}
  }

  componentDidMount(){
    document.title = "Purchase " + this.props.match.params.purchase_id
    this.getPurchase(this.props.match.params.purchase_id).then((response)=>{
      this.setState({purchase:response.data.purchase,
        settings: response.data.settings,
        company_profile: response.data.company_profile, loading:false})
    })
  }

  print(e) {
    e.preventDefault();
    window.print();
  }

  editLink(){
    this.props.history.push("/purchases/edit/"+this.props.match.params.purchase_id)
  }

  getPurchase(purchase_id) {
    return axios({
      url: '/get_purchase/?serial='+purchase_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }


  render() {

    let settings = getUserSettings()
    let pageSize = <A4Portrait />

    switch (settings.invoice_style) {
      case "a4p":
        pageSize = <A4Portrait />
        break;
      case "a4l":
        pageSize = <A4Landscape />
        break;
      case "a5p":
        pageSize = <A5Portrait />
        break;
      case "a5l":
        pageSize = <A5Landscape />
        break;
      default:
        pageSize = <A4Portrait />
    }


    let invoiceFontSize = invoiceFont(settings.invoice_font_size)

    let preview_style
    if(typeof settings !== "undefined" && settings !== null && settings.item_track_batches) {
      preview_style = <div>
      {pageSize}
      {invoiceFontSize}
      <PurchasePharma purchase={this.state.purchase} company={this.state.company_profile} />
      </div>
    }
    else {
      preview_style = <div><A4Portrait /><PurchaseA4 purchase={this.state.purchase} company={this.state.company_profile} /></div>
    }

          let editLink = <Link to={"/purchases/edit/"+this.props.match.params.purchase_id} className="btn btn-primary" >Edit</Link>

          let printLink = <Link to="#" className="btn btn-success" onClick={this.print}>Print <span className="hidden-sm">(Ctrl+p)</span></Link>
          let createNew = <Link to="/purchases/create/" className="btn btn-primary">Create New Purchase</Link>

            if(this.state.loading) {
                return <div><Loader /> </div>
            }
            else {
              return <div>
                    <section className="small">
                      <div className="hidden-print pull-left">
                        <ul className="list-inline">
                          <li>{editLink}</li>
                          <li>{printLink}</li>
                          <li>{createNew}</li>
                        </ul>
                      </div>
                    </section>
                    {preview_style}
                  </div>
            }


  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/previewpurchase.js